import { useEffect, useState } from "react";

/**
 * INTEL CONSOLE v2 — global ambient layers.
 * Mounted once at app shell. Pure decoration, pointer-events: none.
 */
export const AmbientLayers = () => {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const h = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener?.("change", h);
    return () => mq.removeEventListener?.("change", h);
  }, []);

  return (
    <>
      <div className="intel-vignette" aria-hidden />
      <div className="intel-scanlines" aria-hidden />
      {!reduced && <div className="intel-grain" aria-hidden />}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[1]"
        style={{
          background:
            "radial-gradient(80vw 60vh at 100% -10%, hsl(var(--primary) / 0.10), transparent 60%), radial-gradient(70vw 50vh at -10% 110%, hsl(var(--primary) / 0.06), transparent 60%)",
        }}
      />
    </>
  );
};
